// src/utils/api-measurements.js
import { supabase } from './supabase.js';

// Crear medición (usa block_id para el nuevo esquema de bloques)
export async function addMeasurement({
  calibration_id,
  block_id,
  setpoint,
  reading,
  unit,
  ref_std_unc = null,
  repeatability_std = null,
  resolution = null,
  drift_std = null,
  other_std = null,
  coverage_k = 2
}) {
  const { data, error } = await supabase
    .from('measurements')
    .insert([{
      calibration_id,
      block_id,
      setpoint,
      reading,
      unit,
      ref_std_unc,
      repeatability_std,
      resolution,
      drift_std,
      other_std,
      coverage_k
    }])
    .select('*');
  if (error) throw error;
  return data || [];
}

// Listado por bloque (para la tabla/gráfico del bloque activo)
export async function listMeasurementsByBlock(block_id) {
  const { data, error } = await supabase
    .from('measurements')
    .select('*')
    .eq('block_id', block_id)
    .order('setpoint', { ascending: true });
  if (error) throw error;
  return data || [];
}

// Todas las mediciones de una calibración (para PDF/Excel con todas las tablas)
export async function listMeasurementsByCalibration(calibration_id) {
  const { data, error } = await supabase
    .from('measurements')
    .select('*')
    .eq('calibration_id', calibration_id)
    .order('block_id', { ascending: true })
    .order('setpoint', { ascending: true });
  if (error) throw error;
  return data || [];
}

// Eliminar una medición
export async function deleteMeasurement(measurement_id) {
  const { error } = await supabase
    .from('measurements')
    .delete()
    .eq('id', measurement_id);
  if (error) throw error;
  return true;
}
